import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
   }

  opt1(name: string) {
    document.getElementById(name).style.transform = "scale(1.2)";
    document.getElementById(name).style.transition = "transform .4s";
    document.getElementById(name).style.padding = "4px";
  }
  opt2(name: string) {
    document.getElementById(name).style.transform = "scale(1.0)";
    document.getElementById(name).style.padding = "0px";
    document.getElementById(name).style.transition = "transform .4s";
  }

}


// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/inicio/inicio.component.ts